module.exports = __webpack_public_path__ + "static/media/klenty-logo.397f5c59.png";